import React from "react";

function Main() {
    return (
        <main>
            <div className="main--container">
                    <h2> About Me </h2>
                    <p> I am a prevention scientist with a background in psychology and public health. I am currently a doctoral student at the University of Miami. I am interested in the development and evaluation of prevention programs for youth. </p>
                
                    <h2> Interest </h2>
                    <p> My research interests include the development and evaluation of prevention programs for youth. 
                        I am also interested in the use of technology to deliver prevention programs. </p>
            </div>
        </main>
    );
}

export default Main;